/* eslint-disable react-hooks/exhaustive-deps */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { axios, Constants, Globals } from '../../../utils';
import { Select, Button, SelectActions, Input } from '../../../components';
import { useState } from 'react';
import { useEffect } from 'react';

export class ModalProducts extends Component {

  state = {
    page: 1,
    last_page: 1,
    loadingProducts: false,
    searchTimeout: null,
    form: {
      search: '',
      user_id: this.props.user.id,
      quantity: '',
      discount: '',
      warehouse_id: "",
      odoo_division_id: "",
    },
    data: [],
    prices: [],
    selectedProduct: null,
    selectedPrice: '',
    warehouses: this.props.warehouses,
    formatWarehouses: this.props.formatWarehouses,
    config: null,
    divisions: [],
    loadingDivisions: false,
  }

  get isOdooUser() {
    const user = this.props.user;
    return user && ((user.admin ? user.admin.odoo : user.odoo) == 1);
  }

  componentDidMount() {
    this.load();
    this.getConfig();
    if (this.isOdooUser) {
      this.loadDivisions();
    }
  }

  componentWillUnmount() {
    // Limpiar timeout pendiente al desmontar
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
  }

  load = async () => {
    /*
      Si es ADMIN, o no tiene almacen asignado le cargo por defecto los productos del almacen principal
      SI no es ADMIN, y tiene almacen asignado, le cargo por defecto los productos del almacen asignado
    */
    if (this.props.user.level_id == Constants.ROLE_ADMIN) {
      this.onSelectWarehouse(this.props.user.warehouse_principal);
    }
    else {
      if (this.props.user.warehouse_id == null) {
        this.onSelectWarehouse(this.props.user.warehouse_principal);
      }
      else {
        this.onSelectWarehouse(this.props.user.warehouse_id)
      }
    }
  }

  getConfig = () => {
    axios
      .post("sync/config", { user_id: this.props.user.id })
      .then(({ data }) => {
        this.setState({ config: data.config });
      })
      .catch(() => Globals.showError())
      .finally(() => Globals.quitLoading());
  };

  loadDivisions = () => {
    this.setState({ loadingDivisions: true });
    axios
      .post('admin/inventory/odoodivissions', { user_id: this.props.user.id })
      .then(({ data }) => {
        this.setState({ divisions: data.data || [] });
      })
      .catch(() => Globals.showError('Error al cargar las divisiones'))
      .finally(() => this.setState({ loadingDivisions: false }));
  };

  /**
   * Carga una página de productos del almacén con soporte de búsqueda y división.
   * @param {number|string} warehouse_id
   * @param {number} page
   * @param {string} search
   * @param {number|string} odoo_division_id
   */
  fetchProducts = async (warehouse_id, page = 1, search = '', odoo_division_id = null) => {
    if (!warehouse_id) return;

    this.setState({ loadingProducts: true });

    try {
      const divisionId = odoo_division_id !== null ? odoo_division_id : this.state.form.odoo_division_id;
      const payload = {
        web: true,
        user_id: this.props.user.id,
        is_select: true,
        warehouse_id: warehouse_id,
        with_products: true,
        products_with_paginate: true,
        unique_by_size_color: true,
        page,
        ...(search ? { search } : {}),
        ...(divisionId ? { odoo_division_id: divisionId } : {}),
      };

      const res = await axios.post('web/admin/warehouses', payload);

      if (res.data) {
        // Filtrar por negative_stock config (igual que antes)
        let products = (res.data.products || []).map(product => {
          if (this.state.config?.negative_stock == Constants.CONFIG.NO) {
            if ((product.total_quantity ?? 0) <= 0) return null;
          }
          return product;
        }).filter(p => p !== null);

        this.setState({
          data: products,
          page: res.data.current_page ?? page,
          last_page: res.data.last_page ?? 1,
        });
      } else {
        this.setState({ data: [], page: 1, last_page: 1 });
      }
    } catch (error) {
      console.log('Error fetching warehouse products (paginated): ', error);
      Globals.showError('Error al cargar los productos del almacén');
    } finally {
      this.setState({ loadingProducts: false });
    }
  }

  // Búsqueda con debounce: se llama desde onInputChange del SelectActions
  onSearchProducts = (searchValue) => {
    const warehouse_id = this.state.form.warehouse_id;
    if (!warehouse_id) return;

    // Cancelar timeout anterior
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);

    const timeout = setTimeout(() => {
      this.fetchProducts(warehouse_id, 1, searchValue, this.state.form.odoo_division_id);
    }, 400);

    this.setState({ searchTimeout: timeout });
  }

  onSelectWarehouse = async (warehouse_id, odoo_division_id = null) => {
    const divisionId = odoo_division_id !== null ? odoo_division_id : this.state.form.odoo_division_id;
    this.setState(state => ({
      form: {
        ...state.form,
        warehouse_id: warehouse_id,
        odoo_division_id: divisionId,
        search: '',
      },
      data: [],
      page: 1,
      last_page: 1,
      selectedProduct: null,
      selectedPrice: '',
      prices: [],
    }));

    await this.fetchProducts(warehouse_id, 1, '', divisionId);
  }

  goToPage = (page) => {
    const { form } = this.state;
    this.fetchProducts(form.warehouse_id, page, form.search || '', form.odoo_division_id);
  }

  getproducts = async () => {
    Globals.setLoading();

    const form = {
      search: this.state.form.search,
      user_id: this.state.form.user_id,
    };

    axios.post("web/admin/orders/products", form)
      .then(res => {
        if (!res.data) throw Error('No se encontraron los productos');
        this.setState({ data: res.data.products });
      })
      .catch(() => {
        Globals.showError();
      })
      .finally(() => Globals.quitLoading());
  }

  resetForm = async () => {
    await this.setState({
      form: {
        search: '',
        user_id: this.props.user.id,
        quantity: '',
        discount: '',
        warehouse_id: this.state.form.warehouse_id,
        odoo_division_id: this.state.form.odoo_division_id,
      },
      prices: [],
      selectedProduct: null,
      selectedPrice: '',
    });
  }

  change = async (value, target) => {
    await this.setState(state => ({ form: { ...state.form, [target]: value } }));
  }

  onChangeProductSizeColor = async (value, target) => {
    await this.setState(state => ({
      selectedProduct: {
        ...state.selectedProduct,
        [target]: value,
      }
    }));

    this.setPrices();
    this.formatProduct();
  }

  formatProduct = () => {
    const { form, selectedPrice, selectedProduct } = this.state;
    if (!selectedProduct) return;

    const quantity = Number(form.quantity);
    const discount = Number(form.discount || 0);
    const warehouse_id = Number(form.warehouse_id)
    let stock = selectedProduct.stock;

    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      const size_color = selectedProduct.size_colors.find(sc => sc.size_id === selectedProduct.size_id && sc.color_id === selectedProduct.color_id);

      stock = size_color?.stock || 0;
      selectedProduct.altName = selectedProduct.name;
      if (!!size_color?.color) selectedProduct.altName += `, ${size_color.color.name}`;
      if (!!size_color?.size) selectedProduct.altName += `, ${size_color.size.name}`;
    }

    const subtotal = quantity * selectedPrice;

    this.setState({
      selectedProduct: {
        ...selectedProduct,
        product_id: selectedProduct.id,
        quantity,
        stock,
        subtotal,
        discount,
        warehouse_id,
      }
    });

    //Limpio el almacen
    // this.setState(state => ({
    //   form: {
    //     ...state.form,
    //     warehouse_id: '',
    //   }
    // }));
  }

  getPrices = (product) => {
    let size_color = null;
    let prices = product.prices;

    if (product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      size_color = product?.size_colors?.find((i) => {
        if (product.size_id && product.color_id) {
          return i.size_id === product.size_id && i.color_id === product.color_id;
        }
        else if (product.size_id) {
          return i.size_id === product.size_id && !i.color_id;
        }
        else if (product.color_id) {
          return i.color_id === product.color_id && !i.size_id;
        }

        return null;
      });

      prices = size_color?.prices || [];
      product.price = (product?.size_colors.length > 0 ? product?.size_colors[0].sale_price : 0);

    } else {
      product.price = product.sale_price;
    }

    return [
      {
        value: parseFloat(size_color?.sale_price || product.price), // Convertimos a número
        label: `$${Globals.formatMiles(size_color?.sale_price || product.price, true)}`,
      },
      ...(prices || []).map(i => ({
        value: parseFloat(i.price), // Convertimos a número
        label: `$${Globals.formatMiles(i.price, true)}`,
      }))
    ]
  }

  setPrices = async () => {
    const product = Globals.copy(this.state.selectedProduct);
    this.setState({
      prices: this.getPrices(product),
      selectedPrice: '',
    });
  }

  onSelectProduct = async (id) => {
    await this.resetForm();
    const selectedProduct = Globals.copy(this.state.data.find(p => p.id === id));
    let prices = this.getPrices(selectedProduct);
    selectedProduct.size_id = null;
    selectedProduct.color_id = null;

    await this.setState(state => ({
      selectedProduct,
      selectedPrice: '',
      prices,
      form: {
        ...state.form,
        quantity: '',
        discount: '',
      }
    }));

    this.formatProduct();
  }

  onSelectPrice = async (amount) => {
    let decimal = 2
    if (this.props.user?.config?.three_decimals === Constants.STATUS_ACTIVE) {
      decimal = 3;
    }
    await this.setState({ selectedPrice: parseFloat(parseFloat(amount).toFixed(decimal)) });
  }

  onChangeQuantity = async (value) => {
    let maxLimit = null;
    const { selectedProduct } = this.state;
    if (selectedProduct && selectedProduct.limited) {
      if (Array.isArray(selectedProduct.limited)) {
        maxLimit = selectedProduct.limited.length > 0 ? selectedProduct.limited[0].max_quantity : null;
      } else {
        maxLimit = selectedProduct.limited.max_quantity;
      }
    }

    if (maxLimit && Number(value) > Number(maxLimit)) {
      Globals.showError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);
      value = maxLimit;
    }

    await this.change(value, 'quantity');
    if (this.state.selectedProduct) {
      this.formatProduct();
    }
  }

  submit = () => {
    if (!this.isValidForm()) return;

    const product = Globals.copy(this.state.selectedProduct);
    product.name = product?.altName || product.name;
    product.price = this.state.selectedPrice;
    product.sale_price = this.state.selectedPrice;
    product.selected_price = this.state.selectedPrice;

    this.props.onSelectProduct(product, this.state.form.warehouse_id);
    this.resetForm();
  }

  isValidForm = () => {
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    }

    const { selectedPrice, selectedProduct } = this.state;

    console.log('selectedProduct: ', selectedProduct)
    console.log('user: ', this.props.user)

    if (!selectedProduct)
      return onError('Debe seleccionar el producto');

    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      let colors = selectedProduct.size_colors.filter(i => i.color_id).reduce((prev, curr) => prev.set(curr.color_id, curr.color), new Map()).values();
      let sizes = selectedProduct.size_colors.filter(i => i.size_id).reduce((prev, curr) => prev.set(curr.size_id, curr.size), new Map()).values();
      colors = [...colors];
      sizes = [...sizes];

      if (!!colors.length && !selectedProduct.color_id)
        return onError('Debe seleccionar un color');

      if (!!sizes.length && !selectedProduct.size_id)
        return onError('Debe seleccionar una talla');
    }

    if (!selectedProduct)
      return onError('Debe selecciona el producto');

    if (typeof selectedPrice !== 'number')
      return onError('Debe seleccionar el precio');

    if (selectedProduct.discount !== '' && selectedProduct.discount < 0)
      return onError('El porcentaje de descuento no puede ser negativo');

    if (selectedProduct.discount !== '' && selectedProduct.discount > 100)
      return onError('El porcentaje de descuento no puede ser mayor a 100%');

    if (selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.NO) {
      if (selectedProduct.quantity < 1)
        return onError('Debe seleccionar al menos 1');
    } else {
      if (selectedProduct.quantity <= 0)
        return onError('Debe ingresar la cantidad');
    }

    // Validar stock por talla/color seleccionada (para productos SIZE_COLOR)
    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      const size_color = selectedProduct.size_colors?.find(sc =>
      (selectedProduct.size_id && selectedProduct.color_id
        ? sc.size_id === selectedProduct.size_id && sc.color_id === selectedProduct.color_id
        : selectedProduct.size_id
          ? sc.size_id === selectedProduct.size_id && !sc.color_id
          : selectedProduct.color_id
            ? sc.color_id === selectedProduct.color_id && !sc.size_id
            : false)
      );
      const sizeStock = size_color?.stock ?? 0;
      if (sizeStock <= 0) {
        return onError(`La talla/color seleccionada no tiene stock disponible`);
      }
      if (this.state.config?.negative_stock == Constants.CONFIG.NO && selectedProduct.quantity > sizeStock) {
        return onError(`No hay suficiente stock para esta talla/color (${sizeStock} disponibles)`);
      }
    } else {
      // Si en config, el negative_stock es NO, evaluamos el stock
      if (this.state.config?.negative_stock == Constants.CONFIG.NO) {
        // Si es el almacen principal el stock esta en stock, si es otro almacen esta en total_quantity
        if (selectedProduct.warehouse_id === this.props.user.warehouse_principal) {
          if (selectedProduct.quantity > selectedProduct.stock) {
            return onError(`No hay suficiente stock (${selectedProduct.stock})`);
          }
        }
        else {
          if (selectedProduct.quantity > selectedProduct.total_quantity) {
            return onError(`No hay suficiente stock (${selectedProduct.total_quantity})`);
          }
        }
      }
    }

    let maxLimit = null;
    if (selectedProduct.limited) {
      if (Array.isArray(selectedProduct.limited)) {
        maxLimit = selectedProduct.limited.length > 0 ? selectedProduct.limited[0].max_quantity : null;
      } else {
        maxLimit = selectedProduct.limited.max_quantity;
      }
    }

    if (maxLimit && Number(selectedProduct.quantity) > Number(maxLimit)) {
      return onError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);
    }

    return true;
  }

  render() {

    const { form, data, prices, selectedProduct, selectedPrice, page, last_page, loadingProducts, divisions, loadingDivisions } = this.state;
    const isOdoo = this.isOdooUser;

    return (
      <div className="mt-2">
        {/* comentado para prod */}
        {!isOdoo && (
          (
            this.state.warehouses.length > 1 && (
              this.props.user.level_id == Constants.ROLE_ADMIN ||
              (this.props.user.level_id == Constants.ROLE_MODERATOR && this.props.user.warehouse_id === null)
            )
          ) ?
            <div className="col-12 select-product">
              <Select
                label="Almacén"
                labelClass="material"
                disabledFirst
                value={form.warehouse_id}
                options={this.state.formatWarehouses}
                onChange={e => this.onSelectWarehouse(e.target.value)}
              />
            </div>
            : ''
        )}

        {isOdoo && (
          <div className="col-12 select-product">
            <Select
              label={loadingDivisions ? 'Cargando divisiones...' : 'División (Odoo)'}
              labelClass="material"
              value={form.odoo_division_id}
              options={divisions.map(d => ({ value: d.id, label: d.name }))}
              onChange={e => {
                const odoo_division_id = e.target.value;
                const selectedDivision = divisions.find(d => d.id == odoo_division_id);
                if (selectedDivision && selectedDivision.warehouse_id) {
                  this.onSelectWarehouse(selectedDivision.warehouse_id, odoo_division_id);
                } else {
                  this.setState(state => ({
                    form: { ...state.form, odoo_division_id },
                    data: [],
                    page: 1,
                    last_page: 1,
                    selectedProduct: null,
                    selectedPrice: '',
                    prices: []
                  }));
                }
              }}
            />
          </div>
        )}

        <div className="col-12 select-product">
          <SelectActions
            label="Nombre o Código"
            isSearchable
            options={data.map(item => ({
              ...item,
              value: item.id,
              label: `${String(item.code).toLowerCase().toUpperCase()} - ${item.name}`,
              actions: [],
            }))}
            value={selectedProduct?.id || null}
            onChange={this.onSelectProduct}
            onInputChange={this.onSearchProducts}
          />

          {/* Controles de paginación */}
          {last_page > 1 && (
            <div className="product-pagination">
              <button
                className="btn-page"
                disabled={page <= 1 || loadingProducts}
                onClick={() => this.goToPage(page - 1)}
              >
                ‹ Anterior
              </button>
              <span className="page-info">
                {loadingProducts ? 'Cargando...' : `Página ${page} de ${last_page}`}
              </span>
              <button
                className="btn-page"
                disabled={page >= last_page || loadingProducts}
                onClick={() => this.goToPage(page + 1)}
              >
                Siguiente ›
              </button>
            </div>
          )}

          {/* Indicador de carga cuando solo hay una página */}
          {loadingProducts && last_page <= 1 && (
            <div className="product-pagination">
              <span className="page-info">Cargando productos...</span>
            </div>
          )}
        </div>

        {selectedProduct?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && (
          <div className="col-12">
            <SizeColorForm
              product={selectedProduct}
              onChange={(value, target) => this.onChangeProductSizeColor(value, target)}
            />
          </div>
        )}

        <div className="col-12 price-discount">
          <div className="select-price">
            <Select
              label="Precio"
              labelClass="material"
              disabledFirst
              value={selectedPrice}
              options={prices}
              onChange={e => this.onSelectPrice(e.target.value)}
            />
          </div>

          <div className="select-discount" style={{ display: 'flex', flexDirection: 'column' }}>
            <label className="material" style={{ marginBottom: '5px' }}>Descuento (%)</label>
            <input
              type="text"
              placeholder="Opcional"
              className="form-control material"
              value={form.discount}
              onChange={async (e) => {
                let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
                if ((val.match(/\./g) || []).length > 1) {
                  val = val.substring(0, val.length - 1);
                }
                await this.change(val, 'discount');
                if (!!selectedProduct) this.formatProduct();
              }}
            />
          </div>
        </div>

        <div className="container-data">
          <span>Cantidad</span>
          <NumberFormat
            className="quantity-input"
            placeholder="0"
            value={form.quantity}
            allowEmptyFormatting={true}
            //decimalScale={0}
            decimalScale={selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.YES ? 2 : 0}
            thousandSeparator="." // Separador de miles como punto
            decimalSeparator="," // Separador de decimales como coma
            allowNegative={false}
            //onValueChange={({ value }) => this.onChangeQuantity(value)}
            onValueChange={({ floatValue }) => this.onChangeQuantity(floatValue || "")}
            isAllowed={({ floatValue }) => {
              if (floatValue === undefined) return true;
              return selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.YES ? true : floatValue % 1 === 0;
            }}
          />
        </div>

        <div className="actions">
          <Button onClick={() => this.submit()}>
            CARGAR
          </Button>

          <Button onClick={() => this.props.onClose()}>
            FINALIZAR
          </Button>
        </div>
      </div>
    )
  }
}

export const SizeColorForm = ({ product, onChange }) => {

  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);

  function getUniqueItems() {
    const _colors = new Map();
    const _sizes = new Map();

    if (product && product.size_colors) {
      product.size_colors.forEach(i => {
        if (i.color_id && i.color) _colors.set(i.color_id, i.color);
        if (i.size_id && i.size) _sizes.set(i.size_id, i.size);
      });
    }

    setColors([..._colors.values()]);
    setSizes([..._sizes.values()]);
  }

  useEffect(() => {
    getUniqueItems();
  }, [product]);

  // Helper: obtener el stock de una talla (considerando color si aplica)
  function getSizeStock(size) {
    if (!product || !product.size_colors) return null;
    const matches = product.size_colors.filter(sc => sc.size_id === size.id);
    if (matches.length === 0) return null;
    // Si hay color seleccionado, filtrar por color también
    if (product.color_id) {
      const specific = matches.find(sc => sc.color_id === product.color_id);
      return specific ? (specific.stock ?? 0) : null;
    }
    // Sin color, sumar stock de todas las variantes de esa talla
    return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
  }

  function getColorStock(color) {
    if (!product || !product.size_colors) return null;
    const matches = product.size_colors.filter(sc => sc.color_id === color.id);
    if (matches.length === 0) return null;
    if (product.size_id) {
      const specific = matches.find(sc => sc.size_id === product.size_id);
      return specific ? (specific.stock ?? 0) : null;
    }
    return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
  }

  return (
    <div className="size-colors-form">
      {!!sizes.length && (
        <div className="sizes">
          <Select
            label="Talla"
            labelClass="material"
            className="material"
            disabledFirst
            options={sizes.map(item => {
              const stock = getSizeStock(item);
              const noStock = stock !== null && stock <= 0;
              return {
                value: item.id,
                label: noStock ? `${item.name} (sin stock)` : item.name,
                disabled: noStock,
              };
            })}
            value={product.size_id}
            onChange={e => onChange(Number(e.target.value), 'size_id')}
          />
        </div>
      )}

      {!!colors.length && (
        <div className="colors">
          <SelectActions
            label="Color"
            options={colors.map(item => {
              const stock = getColorStock(item);
              const noStock = stock !== null && stock <= 0;
              return {
                value: item.id,
                label: noStock
                  ? (<span style={{ opacity: 0.4 }}><div className="circle" style={{ backgroundColor: item.hex, display: 'inline-block' }} /> (sin stock)</span>)
                  : (<div className="circle" style={{ backgroundColor: item.hex }} />),
                actions: [],
                isDisabled: noStock,
              };
            })}
            value={product.color_id}
            onChange={id => onChange(Number(id), 'color_id')}
          />
        </div>
      )}
    </div>
  );
}

export default connect(state => ({
  user: state.user,
}))(ModalProducts)